import { makeStyles } from 'tss-react/mui';


export const useStyles = makeStyles()(() => ({
  calendarLoader: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999,
  },

  cursorInherit: {
    cursor: 'inherit',
  },

  calendarContent: {
    flexGrow: 1,
  },
  calendarContentDisabled: {
    flexGrow: 1,
    '& .fc .fc-timegrid-cols': {
      cursor: 'default !important',
      pointerEvents: 'none',
      zIndex: 2,
    }
  },
}));
